export default __webpack_public_path__ + "static/media/swiss.1dd96ae8.png";